export const DIRECT_DEBIT_PAYMENT = 0
export const OTHER_PAYMENT = 1

export const IBAN_MAX_LENGTH = 34
export const BIC_MAX_LENGTH = 11
export const BANKNAME_MAX_LENGTH = 35

export const paymentType = [
    { id: 0, value: DIRECT_DEBIT_PAYMENT, label: "partner:partner_info.mandate.direct_debit_payment" },
    { id: 1, value: OTHER_PAYMENT, label: "partner:partner_info.mandate.other_payment" },
]